// Widget: Erwähnungen — ungelesene @-Mentions aus dem Notification-Feed.

import { useLocation } from "wouter-preact";
import { AtSign } from "lucide-preact";
import { useNotifications } from "../../store/notifications";

export function MentionsWidget(): preact.JSX.Element {
  const notifs = useNotifications();
  const [, setLocation] = useLocation();

  if (notifs.loading)
    return <p class="text-xs text-[color:var(--color-on-surface-variant)] italic">Lädt…</p>;
  // „Offen" heisst hier auch: die Aufgabe laeuft noch. Eine Erwaehnung auf
  // einer erledigten Aufgabe ist kein offener Posten mehr (`task_done` kommt
  // serverseitig abgeleitet mit) — sie stuende hier sonst unter „offene
  // Erwaehnungen", obwohl es nichts mehr zu tun gibt.
  const items = notifs.items
    .filter((n) => n.type === "mention" && !n.read_at && !n.task_done)
    .slice(0, 5);
  if (items.length === 0)
    return (
      <p class="text-xs text-[color:var(--color-on-surface-variant)] italic">
        Keine offenen Erwähnungen.
      </p>
    );

  return (
    <ul class="flex flex-col gap-1.5 text-sm">
      {items.map((n) => (
        <li key={n.id}>
          <button
            type="button"
            onClick={() => {
              if (n.link) setLocation(n.link);
            }}
            class="w-full flex items-start gap-2 text-left rounded px-1.5 py-1 hover:bg-[color:var(--color-surface-container-low)]"
          >
            <AtSign
              size={14}
              class="text-[color:var(--color-primary)] shrink-0 mt-0.5"
            />
            <div class="flex-1 min-w-0">
              <p class="truncate text-sm text-[color:var(--color-on-surface)]">
                {n.title}
              </p>
              {n.body && (
                <p class="truncate text-micro text-[color:var(--color-on-surface-variant)]">
                  {n.body}
                </p>
              )}
            </div>
          </button>
        </li>
      ))}
    </ul>
  );
}
